<template>
	<span :class="statusBadgeClass" v-html="display"/>
</template>
<script>
export default {
	props: {
		group: {
			type: String,
			required: true,
		},
		status: {
			type: String,
			required: true,
		},
	},

	computed: {
		statusBadgeClass() {
			return [
				"badge",
				this.group,
				this.stringer(this.status).replace(/([A-Z])/g, "-$1").replace("_", "-").lower().value,
				// this.status.replace(/([A-Z])/g, "-$1").toLowerCase(),
			].filter(function (item) {
				return item;
			}).join("--");
		},
		display() {
			let enumName = this.group.split("-").map(function (part) {
				return part.charAt(0).toUpperCase() + part.slice(1);
			}).join("") + "StatusEnum";

			if (!this.$enum(enumName).has(this.status)) {
				return this.$present("ucWords", this.status);
			}

			return this.$enum(enumName).display(this.status);
		},
	},
};
</script>
